exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._416bnuz76av3993kg64xh6zgjcafr4sx7a5p51kre1vk46zxybddmqu15ch4recujbe7h6bs9z6p3aajvh8hcr6hmp1hq42f1rnnhev-AccountsReportView-module-asDisabled{opacity:.4;pointer-events:none}", "", {"version":3,"sources":["C:/a/_work/5/s/src/tables/AccountsReportView/C:/a/_work/5/s/src/tables/AccountsReportView/AccountsReportView.module.scss"],"names":[],"mappings":"AAAA,+IACE,WACA,mBAAoB,CACrB","file":"AccountsReportView.module.scss","sourcesContent":[".asDisabled {\r\n  opacity: 0.4;\r\n  pointer-events: none;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"asDisabled": "_416bnuz76av3993kg64xh6zgjcafr4sx7a5p51kre1vk46zxybddmqu15ch4recujbe7h6bs9z6p3aajvh8hcr6hmp1hq42f1rnnhev-AccountsReportView-module-asDisabled"
};